/* Pan tool selection toggler when using mouse middle button(mmb) */
import { filter, fromEvent, Subject, takeUntil } from "rxjs";
import { CornerstoneTool, ViewWindowIndex } from './data';
import { StateManagerProjectService } from "@state-manager/state-manager-project.service";

export let panHighlight: boolean = false;
export let pan3dHighlight: boolean = false;

let panToolObs$ = new Subject<boolean>();
export let panToolSub$ = panToolObs$.asObservable();

let pan3dToolObs$ = new Subject<boolean>();
export let pan3dToolSub$ = pan3dToolObs$.asObservable();

export let destroyObs$ = new Subject<void>();

enum mouse {
    down = 'mousedown',
    up = 'mouseup'
}

export function panToolSelectionToggler(targetSelector: any, stateManagerProjectService: StateManagerProjectService): void {
    const VIEWER_ID = 'viewer';

    for (let i = 1; i < 4; i++) {
      const viewerElement = targetSelector.querySelector(`#${VIEWER_ID}${i}`);
      subscriptionEvent(viewerElement, mouse.down, stateManagerProjectService);
      subscriptionEvent(viewerElement, mouse.up, stateManagerProjectService);
    }

    const BONE_MODEL_VIEWER_ID = 'viewer-OCC';
    const viewName3d = '3D';
    const viewer3dElement = targetSelector.querySelector(`#${BONE_MODEL_VIEWER_ID}`);
    subscriptionEvent(viewer3dElement, mouse.down, stateManagerProjectService, viewName3d);
    subscriptionEvent(viewer3dElement, mouse.up, stateManagerProjectService, viewName3d);
}

function subscriptionEvent(targetSelector: any, eventType: string, stateManagerService: StateManagerProjectService, viewName = ''): void {
    const MOUSE_MIDDLE_BUTTON = 1;

    fromEvent<MouseEvent>(targetSelector, eventType)
      .pipe(
        filter(event => stateManagerService.currentSelectedWindow !== ViewWindowIndex.Empty && event.button === MOUSE_MIDDLE_BUTTON),
        takeUntil(destroyObs$)
      )
      .subscribe((event) => {
        if (!viewName) {
            const tool = stateManagerService.currentTool as CornerstoneTool;
            panHighlight = (tool === CornerstoneTool.EmptyTool || ![CornerstoneTool.Pan, CornerstoneTool.Zoom].includes(tool)) ? toggle(eventType) : false;
            panToolObs$.next(panHighlight);
        } else {
            const tool = stateManagerService.current3dTool;
            pan3dHighlight = !tool ? toggle(eventType) : false;
            pan3dToolObs$.next(pan3dHighlight);
        }
    });
}

function toggle(event: string): boolean {
    return event === mouse.down ? true : false;
}

export function cleanupSubscriptions(): void {
    destroyObs$.next();
    destroyObs$.complete();
}
